<template>
  <div class="container">
    <div class="panel panel-default">
      <div class="panel-body" id="imput-form">
        <div class="signup">
          <h2>ユーザー登録</h2>
          <form @submit.prevent="singup" id="imput-form">
            <p>
            </p>
            <p>
              <label for="form_1" class="control-label">メールアドレス</label>
              <input type="text" class="form-control"  v-model="userId" required>
            </p>
            <p>
              <label for="form_1" class="control-label">氏名</label>
              <input type="text" class="form-control"  v-model="name" required>
            </p>
            <p>
              <label for="form_1" class="control-label">パスワード</label>
              <input type="password" class="form-control"  v-model="password" required>
            </p>
            <p>
              <label for="form_1" class="control-label">パスワード(確認)</label>
              <input
                type="password"
                class="form-control"
                v-model="passwordConfirm"
                required
              >
            </p>
            <p align="right">
            <button class="btn btn-outline-secondary">登録</button>
            </p>
          </form>
          <br>
        
    <router-link to="/">ログイン</router-link>
    <router-link to="/Confirmcode">確認コード入力</router-link>
    </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Signup",
  data() {
    return {
      userId: "",
      name: "",
      password: "",
      passwordConfirm: ""
    }
  },
  methods: {
    singup() {
      if (
        this.userId &&
        this.name &&
        this.password === this.passwordConfirm
      ) {
        this.$cognito
          .signUp( this.userId, this.name, this.password)
          .then(resutl => {
            // 登録に成功したら、確認コードの入力画面を表示
            this.$router.replace("/confirmcode")
          })
          .catch(err => {
            alert("パスワードは最小8文字で数字、特殊文字、大文字、小文字を使用してください。")
            console.log(err)
          });
      }
    }
  }
};
</script>

<style scoped >
h2 {
  text-align: center;
}
div {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue